// ============================================================================
// Dashboard — thin switcher between DashboardV1 (original snap-chart.ai)
// and DashboardV3 (2026 viral redesign: TDI hero, streak, latest verdicts,
// share cards, clean navbar). Driven by the admin Site Design toggle.
// ============================================================================
import React from 'react';
import { useDesignVersion } from '@/hooks/useDesignVersion';
import DashboardV1 from './DashboardV1';
import DashboardV3 from './DashboardV3';

const Dashboard = () => {
  const v = useDesignVersion();
  return v === 'v1' ? <DashboardV1 /> : <DashboardV3 />;
};

export default Dashboard;
